import { useCallback } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationRequestListByCInDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationRequestList | undefined;
};

export const useReservationListByCInDateQueryData = () => {
	/**
	 * QueryData へ変換
	 */
	const onConvertQueryData = useCallback(
		({ serverData }: Props): Result => ({
			queryData: serverData
				? {
						hotelName: serverData.reservationRequestListByCInDate.hotelName,
						hotelPrefecture: serverData.reservationRequestListByCInDate.hotelPrefecture,
						reservationList: serverData.reservationRequestListByCInDate.reservations,
					}
				: undefined,
		}),
		[],
	);

	return {
		onConvertQueryData,
	};
};
